import { render } from "./NewDatasourcePreview.vue?vue&type=template&id=e3a7f8a6&scoped=true&ts=true"
import script from "./NewDatasourcePreview.vue?vue&type=script&lang=ts"
export * from "./NewDatasourcePreview.vue?vue&type=script&lang=ts"

import "./NewDatasourcePreview.vue?vue&type=style&index=0&id=e3a7f8a6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3a7f8a6"]])

export default __exports__